import React, {Component} from 'react';
import {withTranslation} from "react-i18next";
import DefaultLayout from "../../components/DefaultLayout";
import {DatePicker, List, LocaleProvider} from 'antd-mobile'
import { createForm } from 'rc-form';
import BottomPanel from "../../components/BottomPanel";
import {SelectField, TextField} from "react-md";
import {notification} from "antd";
import * as _ from "lodash";
import InsuBrandService from "../../apiServices/InsuBrandService";
import enUS from "antd-mobile/lib/locale-provider/en_US";
import CarInsuranceService from "../../apiServices/CarInsuranceService";

const nowTimeStamp = Date.now();
const now = new Date(nowTimeStamp);
const expireContract = [
    {label: '6 Tháng', value: 6},
    {label: '12 Tháng', value: 12},
    {label: '15 Tháng', value: 15},
    {label: '18 Tháng', value: 18},
    {label: '21 Tháng', value: 21},
    {label: '24 Tháng', value: 24},
    {label: '30 Tháng', value: 30},
];

class InsuranceInfo extends Component {
    constructor(props){
        super(props);

        const urlParams = new URLSearchParams(window.location.search);
        const object_id = urlParams.get('object_id');
        const buynow = urlParams.get('buynow');

        this.state = {
            height: props.height,
            hasError: false,
            hasInsurance: 1,
            object_id: object_id,
            hiddenBtn: false,
            insList: [],
            insurance_id: 0,
            expire_in: '',
            amount: 0,
            buynow: buynow,
            date: now,
            expireContractVal: 12,
            carInsurance: null,
        };
    }

    componentDidMount() {
        this.setState({height: window.innerHeight + 'px'});

        InsuBrandService.listBrand().then(response => {
            this.setState({insList: response.data});
        }).catch(function(error){
            console.log(error);
        });

        CarInsuranceService.getDetail(this.state.object_id).then(response => {
            this.setState({carInsurance: response.data, amount: response.data.amount});
        }).catch(function (error) {
            console.log(error);
        });
    }

    insBrandSelect = (value) => {
        this.setState({insurance_id: value});
    };

    expireContractChange = e => {
        let monthSelect = parseInt(e[0]);
        this.setState({expireContractVal: monthSelect});
    };

    contractAmountChange = (value) => {
        let val = value.replace(/,/g, "");
        if(isNaN(val)){
            this.setState({amount: 0});
        }else {
            this.setState({amount: parseInt(val)});
        }
    };

    formSubmit = () => {
        if (this.state.insurance_id === 0){
            notification['error']({
                message: 'Bạn chưa chọn hãng Bảo hiểm',
                description: '',
            });
        } else if (this.state.amount === 0){
            notification['error']({
                message: 'Bạn chưa nhập giá trị HĐ',
                description: '',
            });
        }else if (this.state.expire_in === ''){
            notification['error']({
                message: 'Bạn chưa chọn thời hạn HĐ',
                description: '',
            });
        }else{
            CarInsuranceService.update({
                'car_id': this.state.object_id,
                'insurance_id': this.state.insurance_id,
                'amount': this.state.amount,
                'start_date': this.state.date,
                'expire_in': this.state.expire_in,
            }).then(response => {
                console.log(response);
                if(response.code===0){
                    this.setState({hiddenBtn: true});
                    notification['success']({message: 'Lưu thông tin thành công', description: '',});
                    this.props.history.push('/chi-tiet-xe?id='+this.state.object_id);
                }else{
                    notification.error({
                        message: '',
                        description: _.get('error', 'Lỗi lưu thông tin', 'Error'),
                    });
                }
            }).catch(error => {
                notification.error({
                    message: error,
                    description: _.get(error, 'Lỗi lưu thông tin', 'Error'),
                });
            });
        }

        //console.log(this.state);
    };

    render() {
        return (
            <div className='App-block bgWhite' style={{minHeight: this.state.height}}>
                <DefaultLayout {...this.props} title="Thông tin bảo hiểm" classNameContent="bgWhite" page_type={1} hiddenFt={true} showBottomPanel={true}>
                    <div className="wrap-content">
                        <SelectField
                            id="select-insurance"
                            label="Chọn hãng Bảo hiểm?"
                            placeholder="Chọn hãng Bảo hiểm"
                            itemLabel="name"
                            itemValue="id"
                            menuItems={this.state.insList}
                            className="md-cell md-cell--12"
                            sameWidth
                            value={this.state.carInsurance?this.state.carInsurance.insurance_id:''}
                            onChange={this.insBrandSelect}
                            position={SelectField.Positions.BOTTOM_LEFT}
                        />

                        <TextField
                            id="amount"
                            label="Giá trị Hợp đồng"
                            lineDirection="center"
                            placeholder=""
                            className="md-cell md-cell--12"
                            onChange={e => this.contractAmountChange(e)}
                            value={Number(this.state.amount).toLocaleString('en')}
                        />

                        <SelectField
                            id="expire_in"
                            label="Thời hạn Hợp đồng:"
                            placeholder="Chọn thời hạn"
                            itemLabel="label"
                            itemValue="value"
                            menuItems={expireContract}
                            className="md-cell md-cell--12"
                            sameWidth
                            value={this.state.carInsurance?this.state.carInsurance.expire_in:''}
                            onChange={value => this.setState({expire_in: value})}
                            position={SelectField.Positions.BOTTOM_LEFT}
                        />

                        <LocaleProvider locale={enUS}>
                            <DatePicker mode="date" title="Chọn ngày" extra="Chọn"
                                        value={this.state.date}
                                        onChange={date => this.setState({ date })}
                                        okText="OK"
                                        dismissText="Hủy"
                                        format="YYYY-MM-DD"
                            >
                                <List.Item wrap arrow="horizontal">Hiệu lực từ ngày: </List.Item>
                            </DatePicker>
                        </LocaleProvider>

                    </div>
                </DefaultLayout>
                <BottomPanel handleClick={this.formSubmit} hidden={this.state.hiddenBtn} title={"Tiếp tục"} actionType='submit' />
            </div>
        )
    }
}

InsuranceInfo = createForm()(InsuranceInfo);

export default (withTranslation())(InsuranceInfo);